export default __webpack_public_path__ + "static/media/headphone_white.cb8c4644.svg";